import appInsights from "../config/appInsights";

export const loggerService = {
  trackPageView,
  trackEvent,
  trackException,
  trackTrace,
  getLoggerSettings,
};

// get setting from session; otherwise from environment variables
function getLoggerSettings() {
  // check if settings are in session
  const logger = sessionStorage.getItem("logger");

  // read from environment variables and add to session
  if (logger === "undefined" || logger == null || logger === "null") {
    const environmentSettings = {
      consolePageView: JSON.parse(
        process.env.REACT_APP_ENABLE_LOGS_TRACK_PAGE_VIEW_CONSOLE ?? "true",
      ),
      consoleEvent: JSON.parse(
        process.env.REACT_APP_ENABLE_LOGS_TRACK_EVENT_CONSOLE ?? "true",
      ),
      consoleException: JSON.parse(
        process.env.REACT_APP_ENABLE_LOGS_TRACK_EXCEPTION_CONSOLE ?? "true",
      ),
      consoleTrace: JSON.parse(
        process.env.REACT_APP_ENABLE_LOGS_TRACK_TRACE_CONSOLE ?? "true",
      ),
      appInsightsPageView: JSON.parse(
        process.env.REACT_APP_ENABLE_LOGS_TRACK_PAGE_VIEW_APPINSIGHTS ??
          "false",
      ),
      appInsightsEvent: JSON.parse(
        process.env.REACT_APP_ENABLE_LOGS_TRACK_EVENT_APPINSIGHTS ?? "false",
      ),
      appInsightsException: JSON.parse(
        process.env.REACT_APP_ENABLE_LOGS_TRACK_EXCEPTION_APPINSIGHTS ??
          "false",
      ),
      appInsightsTrace: JSON.parse(
        process.env.REACT_APP_ENABLE_LOGS_TRACK_TRACE_APPINSIGHTS ?? "false",
      ),
    };

    sessionStorage.setItem("logger", JSON.stringify(environmentSettings));
    return environmentSettings;
  } else {
    return JSON.parse(logger);
  }
}

// Logs that a page, or similar container was displayed to the user.
function trackPageView(name: string, url: string) {
  const logger = getLoggerSettings();
  if (logger?.consolePageView) {
    console.log({ name: name, uri: url, date: new Date().toLocaleString() });
  }
  if (logger?.appInsightsPageView) {
    appInsights.trackPageView({ name, uri: url });
  }
}

// Log a user action or other occurrence
function trackEvent(name: string, properties?: unknown) {
  const logger = getLoggerSettings();
  if (logger?.consoleEvent) {
    console.log({
      name: name,
      properties: JSON.stringify(properties),
      date: new Date().toLocaleString(),
    });
  }
  if (logger?.appInsightsEvent) {
    appInsights.trackEvent({ name }, { ...(properties as object) });
  }
}

// Log an exception that you have caught.
// Verbose = 0, Information = 1, Warning = 2, Error = 3, Critical = 4
function trackException(
  exception: Error,
  properties?: unknown,
  severityLevel = 3,
) {
  const logger = getLoggerSettings();
  if (logger?.appInsightsException) {
    appInsights.trackException({
      exception,
      severityLevel,
      properties: properties as Record<string, unknown> | undefined,
    });
  }
  if (logger?.consoleException) {
    console.error({
      exception: exception,
      severityLevel: severityLevel,
      properties: JSON.stringify(properties),
      date: new Date().toLocaleString(),
    });
  }
}

// Log a diagnostic scenario such entering or leaving a function
function trackTrace(message: string, properties?: unknown) {
  const logger = getLoggerSettings();
  if (logger?.appInsightsTrace) {
    appInsights.trackTrace({
      message,
      properties: properties as Record<string, unknown> | undefined,
    });
  }
  if (logger?.consoleTrace) {
    console.log({
      message: message,
      properties: JSON.stringify(properties),
      date: new Date().toLocaleString(),
    });
  }
}
